import { render, staticRenderFns } from "./CreateCampaignForm.vue?vue&type=template&id=97c6fb4c"
import script from "./CreateCampaignForm.vue?vue&type=script&lang=js"
export * from "./CreateCampaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports